import {
  Archive,
  Building2,
  LayoutDashboard,
  Sun,
  Users,
  type LucideIcon,
} from "lucide-react";
import { matchPath } from "react-router";

import {
  CONTACT_TYPE_LISTS,
  type CreatableContactType,
} from "../palmtree/constants";

const LIST_ICONS = {
  person: Users,
  company: Building2,
} as const satisfies Record<CreatableContactType, LucideIcon>;

export type PrimaryNavItem = {
  to: string;
  labelKey: string;
  icon: LucideIcon;
  end: boolean;
  /** Opens in a new tab and is never marked active. */
  external?: boolean;
};

// Notion Gebiedsarchief. Once the in-app archive screen (A4) exists, this
// item becomes an internal route `/archief` (drop `external`).
const NOTION_ARCHIVE_URL =
  "https://app.notion.com/p/add0ba6e45204ac2ae8d48f6d23734e9";

export const ARCHIVE_URL =
  import.meta.env.VITE_ARCHIVE_URL || NOTION_ARCHIVE_URL;

export const externalNavAriaLabel = (
  label: string,
  translate: (key: string, options?: Record<string, unknown>) => string,
) => translate("palmtree.nav.external", { label });

export const isPrimaryNavActive = (item: PrimaryNavItem, pathname: string) => {
  if (item.external) return false;
  if (item.end) return pathname === item.to;
  return (
    !!matchPath({ path: `${item.to}/*`, end: false }, pathname) ||
    pathname === item.to
  );
};

// Bedrijven here is contacts with type=company. The companies resource stays
// registered for deals; it is not a primary nav item.
export const PRIMARY_NAV: PrimaryNavItem[] = [
  {
    to: "/",
    labelKey: "palmtree.nav.dashboard",
    icon: LayoutDashboard,
    end: true,
  },
  {
    to: "/vandaag",
    labelKey: "palmtree.nav.vandaag",
    icon: Sun,
    end: false,
  },
  ...CONTACT_TYPE_LISTS.map((list) => ({
    to: list.path,
    labelKey: list.labelKey,
    icon: LIST_ICONS[list.type],
    end: true,
  })),
  {
    to: ARCHIVE_URL,
    labelKey: "palmtree.nav.archive",
    icon: Archive,
    end: true,
    external: true,
  },
];
